import { Injectable } from '@angular/core';
import { CoreTimeService } from '../../../lib/time/core-time.service.js';

@Injectable({
	providedIn: 'root'
})
export class TimeService extends CoreTimeService {}

